// src/components/account-placement/account-placement.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    decorative\n    text\n    theme\n    weight\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment CreditCardNoWrapTextFragment on CreditCardNoWrapText {\n    stylizedText: text {\n      ...EGDSStylizedTextFragment\n    }\n  }\n  ", "\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      ... on UILinkAction {\n        accessibility\n        analytics {\n          ...ClientSideAnalyticsFragment\n        }\n        resource {\n          value\n        }\n        target\n      }\n    }\n    text\n  }\n\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n    accessibility\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment CreditCardSpannableTextInlineContentFragment on CreditCardSpannableTextItem {\n    ... on EGDSPlainText {\n      ...EGDSPlainTextFragment\n    }\n    ... on EGDSStylizedText {\n      ...EGDSStylizedTextFragment\n    }\n    ... on EGDSInlineLink {\n      ...EGDSInlineLinkFragment\n    }\n    ... on CreditCardNoWrapText {\n      ...CreditCardNoWrapTextFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment CreditCardSpannableTextFragment on CreditCardSpannableText {\n    inlineContent {\n      ...CreditCardSpannableTextInlineContentFragment\n    }\n    accessibilityLabel: accessibility\n  }\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment IconFragment on Icon {\n    __typename\n    id\n    token\n    description\n    theme\n    iconSize: size\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment ImageFragment on Image {\n    __typename\n    description\n    url\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  query CreditCardAccountPlacementQuery(\n    $context: ContextInput!\n    $variant: CreditCardAccountPlacementVariant!\n    $sourcePage: CreditCardAccountPlacementSourcePage!\n  ) {\n    creditCardAccountPlacement(context: $context, variant: $variant, sourcePage: $sourcePage) {\n      bottomLabel\n      bottomLinkText\n      cardImage {\n        ...ImageFragment\n      }\n      ctaAction {\n        accessibility\n        analytics {\n          ...ClientSideAnalyticsFragment\n        }\n        resource {\n          value\n        }\n        target\n      }\n      ctaIcon {\n        ...IconFragment\n      }\n      stylizedHeading {\n        ...CreditCardSpannableTextFragment\n      }\n      impressionAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      subHeading\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
import React10 from "react";
import { gql as gql10, useQuery } from "@apollo/client";
import { EGDSCard, EGDSCardContentSection, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2 } from "@egds/react-core/images";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText as EGDSText3 } from "@egds/react-core/text";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker, useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/common/constants.ts
var CREDIT_CARD_QUERY_BATCH_KEY = "creditCardQueryBatchKey";
// ../internal/src/common/fragments/client-side-analytics.ts
import { gql } from "@apollo/client";
var ClientSideAnalyticsFragment = gql(_templateObject());
// ../internal/src/components/credit-card-spannable-text/credit-card-spannable-text.tsx
import React7, { Fragment } from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkLayoutPosition } from "@egds/react-core/layout-position";
// ../internal/src/components/credit-card-spannable-text/credit-card-spannable-text-inline-content.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
// ../internal/src/components/benefit-detail/benefit-detail-expando-context.tsx
import React, { createContext, useContext } from "react";
var DEFAULT_CONTEXT = {
  toggleExpando: function () {
    return null;
  },
  togglePopover: function () {
    return null;
  }
};
var BenefitsDetailExpandoContext = createContext(DEFAULT_CONTEXT);
var useExpandoPeekControl = function () {
  return useContext(BenefitsDetailExpandoContext);
};
// ../internal/src/components/credit-card-no-wrap-text/credit-card-no-wrap-text.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSText } from "@egds/react-core/text";
var _obj;
// ../internal/src/components/egds-text/__private/text-decorative.ts
var textDecorationMapper = (_obj = {}, _define_property(_obj, "SUBSCRIPT" /* SUBSCRIPT */, "sub"), _define_property(_obj, "SUPERSCRIPT" /* SUPERSCRIPT */, "sup"), _define_property(_obj, "LINE_THROUGH" /* LINE_THROUGH */, "s"), _obj);
var _obj1;
// ../internal/src/components/egds-text/__private/text-theme.ts
var textThemeMapper = (_obj1 = {}, _define_property(_obj1, "EMPHASIS" /* EMPHASIS */, "emphasis"), _define_property(_obj1, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj1, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj1, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj1, "SECONDARY" /* SECONDARY */, "default"), _define_property(_obj1, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj1, "INVERSE" /* INVERSE */, "inverse"), _obj1);
var _obj2;
// ../internal/src/components/egds-text/__private/text-weight.ts
var textWeightMapper = (_obj2 = {}, _define_property(_obj2, "BOLD" /* BOLD */, "bold"), _define_property(_obj2, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj2, "REGULAR" /* REGULAR */, "regular"), _obj2);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment = gql2(_templateObject1());
var EGDSStylizedText = function (param) {
  var align = param.align,
    inline = param.inline,
    data = param.data,
    size = param.size,
    whiteSpace = param.whiteSpace,
    weightOverride = param.weightOverride;
  var decorative = data.decorative,
    text = data.text,
    theme = data.theme,
    weight = data.weight;
  var themeProps = theme ? textThemeMapper[theme] : void 0;
  var weightProps = weightOverride || (weight ? textWeightMapper[weight] : void 0);
  var TextDecorationTag = decorative ? textDecorationMapper[decorative] : void 0;
  return /* @__PURE__ */React2.createElement(EGDSText, {
    align: align,
    inline: inline,
    size: size,
    theme: themeProps,
    weight: weightProps,
    whiteSpace: whiteSpace
  }, TextDecorationTag ? /* @__PURE__ */React2.createElement(TextDecorationTag, null, text) : /* @__PURE__ */React2.createElement(React2.Fragment, null, text));
};
EGDSStylizedText.fragment = fragment;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/credit-card-no-wrap-text/credit-card-no-wrap-text.tsx
var fragment2 = gql3(_templateObject2(), EGDSStylizedText.fragment);
var CreditCardNoWrapText = function (param) {
  var data = param.data,
    inline = param.inline,
    size = param.size;
  var stylizedText = data.stylizedText;
  return /* @__PURE__ */React3.createElement(EGDSStylizedText, {
    data: stylizedText,
    whiteSpace: "nowrap",
    inline: inline,
    size: size
  });
};
CreditCardNoWrapText.fragment = fragment2;
CreditCardNoWrapText.displayName = "CreditCardNoWrapText";
// ../internal/src/components/egds-text/egds-inline-link.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSLink } from "@egds/react-core/link";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var fragment3 = gql4(_templateObject3(), ClientSideAnalyticsFragment);
var EGDSInlineLink = function (param) {
  var data = param.data,
    linkSize = param.linkSize,
    noWrap = param.noWrap,
    onClick = param.onClick;
  var text = data.text,
    action = data.action;
  var trackClick = useClickTracker();
  var onClickTracking = function () {
    var _action_analytics = action.analytics,
      referrerId = _action_analytics.referrerId,
      linkName = _action_analytics.linkName;
    if (referrerId && linkName) {
      trackClick(referrerId, linkName);
    }
  };
  var onClickWrapper = function (e) {
    onClickTracking();
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  var _action_accessibility;
  return /* @__PURE__ */React4.createElement(EGDSLink, {
    inline: true,
    size: linkSize,
    noWrap: noWrap,
    onClick: onClickWrapper
  }, /* @__PURE__ */React4.createElement("a", {
    href: action.resource.value,
    target: action.target === "EXTERNAL" /* EXTERNAL */ ? "_blank" : "",
    "aria-label": (_action_accessibility = action.accessibility) !== null && _action_accessibility !== void 0 ? _action_accessibility : void 0,
    rel: "noopener"
  }, text));
};
EGDSInlineLink.fragment = fragment3;
EGDSInlineLink.displayName = "sharedui-EGDSInlineLink";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
var fragment4 = gql5(_templateObject4());
var EGDSPlainText = function (param) {
  var align = param.align,
    data = param.data,
    inline = param.inline,
    size = param.size,
    theme = param.theme,
    weight = param.weight;
  var text = data.text;
  return /* @__PURE__ */React5.createElement(EGDSText2, {
    align: align,
    size: size,
    inline: inline,
    theme: theme,
    weight: weight
  }, text);
};
EGDSPlainText.fragment = fragment4;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/credit-card-spannable-text/credit-card-spannable-text-inline-content.tsx
var fragment5 = gql6(_templateObject5(), EGDSPlainText.fragment, EGDSStylizedText.fragment, EGDSInlineLink.fragment, CreditCardNoWrapText.fragment);
var CreditCardSpannableTextInlineContent = function (param) {
  var data = param.data,
    align = param.align,
    linkSize = param.linkSize,
    size = param.size;
  var toggleExpando = useExpandoPeekControl().toggleExpando;
  var onSelfReferencedLinkClick = function (e) {
    e.preventDefault();
    toggleExpando();
  };
  switch (data.__typename) {
    case "EGDSPlainText":
      return /* @__PURE__ */React6.createElement(EGDSPlainText, {
        align: align,
        data: data,
        inline: true,
        size: size
      });
    case "EGDSStylizedText":
      return /* @__PURE__ */React6.createElement(EGDSStylizedText, {
        align: align,
        data: data,
        inline: true,
        size: size
      });
    case "EGDSInlineLink":
      return data.action.resource.__typename === "SelfReferencedURI" ? /* @__PURE__ */React6.createElement(EGDSInlineLink, {
        data: data,
        onClick: onSelfReferencedLinkClick,
        linkSize: linkSize
      }) : /* @__PURE__ */React6.createElement(EGDSInlineLink, {
        data: data,
        linkSize: linkSize
      });
    case "CreditCardNoWrapText":
      return /* @__PURE__ */React6.createElement(CreditCardNoWrapText, {
        data: data,
        inline: true,
        size: size
      });
    default:
      return null;
  }
};
CreditCardSpannableTextInlineContent.fragment = fragment5;
CreditCardSpannableTextInlineContent.displayName = "CreditCardSpannableTextInlineContent";
// ../internal/src/components/credit-card-spannable-text/credit-card-spannable-text.tsx
var fragment6 = gql7(_templateObject6(), CreditCardSpannableTextInlineContent.fragment);
var CreditCardSpannableText = function (param) {
  var data = param.data,
    linkSize = param.linkSize,
    size = param.size,
    align = param.align,
    inline = param.inline;
  var inlineContent = data.inlineContent;
  var Wrapper = function (children) {
    return inline ? /* @__PURE__ */React7.createElement(UitkLayoutPosition, {
      display: "inline"
    }, children) : /* @__PURE__ */React7.createElement("div", null, children);
  };
  return Wrapper(/* @__PURE__ */React7.createElement(React7.Fragment, null, inlineContent.map(function (item, i) {
    return /* @__PURE__ */React7.createElement(Fragment, {
      key: "inl_cont-".concat(i)
    }, /* @__PURE__ */React7.createElement(CreditCardSpannableTextInlineContent, {
      data: item,
      size: size,
      align: align,
      linkSize: linkSize
    }), " ");
  })));
};
CreditCardSpannableText.fragment = fragment6;
CreditCardSpannableText.displayName = "CreditCardSpannableText";
// ../internal/src/components/icon/icon.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
var fragment7 = gql8(_templateObject7());
var Icon = function (param) {
  var data = param.data,
    size = param.size,
    isAriaHidden = param.isAriaHidden,
    themeOverride = param.themeOverride;
  var description = data.description,
    id = data.id,
    token = data.token,
    theme = data.theme;
  return id ? /* @__PURE__ */React8.createElement(EGDSIcon, {
    id: id,
    name: token,
    title: !isAriaHidden ? token : void 0,
    description: !isAriaHidden ? description : void 0,
    theme: themeOverride ? void 0 : theme !== null && theme !== void 0 ? theme : "default",
    size: size !== null && size !== void 0 ? size : EGDSIconSize.SMALL
  }) : null;
};
Icon.fragment = fragment7;
Icon.displayName = "Icon";
// ../internal/src/components/image/image.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSFigure, EGDSImage } from "@egds/react-core/images";
var fragment8 = gql9(_templateObject8());
var Image = function (param) {
  var data = param.data,
    imageFit = param.imageFit,
    ratio = param.ratio;
  var description = data.description,
    url = data.url;
  return /* @__PURE__ */React9.createElement(EGDSFigure, {
    ratio: ratio,
    imageFit: imageFit
  }, /* @__PURE__ */React9.createElement(EGDSImage, {
    alt: description,
    src: url
  }));
};
Image.fragment = fragment8;
Image.displayName = "Image";
// src/__generated__/types.ts
var CreditCardAccountPlacementSourcePage = /* @__PURE__ */function (CreditCardAccountPlacementSourcePage2) {
  CreditCardAccountPlacementSourcePage2["GLOBAL_NAV"] = "GLOBAL_NAV";
  CreditCardAccountPlacementSourcePage2["REWARDS"] = "REWARDS";
  CreditCardAccountPlacementSourcePage2["UNIVERSAL_PROFILE"] = "UNIVERSAL_PROFILE";
  return CreditCardAccountPlacementSourcePage2;
}(CreditCardAccountPlacementSourcePage || {});
var CreditCardAccountPlacementVariant = /* @__PURE__ */function (CreditCardAccountPlacementVariant2) {
  CreditCardAccountPlacementVariant2["MEDIUM"] = "MEDIUM";
  CreditCardAccountPlacementVariant2["SMALL"] = "SMALL";
  return CreditCardAccountPlacementVariant2;
}(CreditCardAccountPlacementVariant || {});
// src/components/account-placement/account-placement.tsx
var __Query = gql10(_templateObject9(), ClientSideAnalyticsFragment, CreditCardSpannableText.fragment, Icon.fragment, Image.fragment);
var smallAccountPlacementOptions = {
  headingSize: 300,
  fallbackImageWidth: ["48px"],
  newImageWidth: ["38px"],
  imageHeight: ["56px"],
  flexGap: "three"
};
var mediumAccountPlacementOptions = {
  headingSize: 500,
  fallbackImageWidth: ["62px"],
  newImageWidth: ["50px"],
  imageHeight: ["72px"],
  flexGap: "four"
};
var ChevronIcon = function (param) {
  var ctaIcon = param.ctaIcon;
  return /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem, {
    grow: 1,
    alignSelf: "center"
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlex, {
    justifyContent: "end"
  }, /* @__PURE__ */React10.createElement(Icon, {
    data: ctaIcon,
    size: EGDSIconSize2.MEDIUM,
    isAriaHidden: true
  })));
};
var AccountPlacement = function (param) {
  var batchKey = param.batchKey,
    inputs = param.inputs,
    skipSsr = param.skipSsr;
  var context = useBexApi().context;
  var trackClick = useClickTracker2();
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      context: {
        batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : CREDIT_CARD_QUERY_BATCH_KEY
      },
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading || error || !(data === null || data === void 0 ? void 0 : data.creditCardAccountPlacement)) {
    return null;
  }
  var _data_creditCardAccountPlacement = data.creditCardAccountPlacement,
    bottomLabel = _data_creditCardAccountPlacement.bottomLabel,
    bottomLinkText = _data_creditCardAccountPlacement.bottomLinkText,
    cardImage = _data_creditCardAccountPlacement.cardImage,
    ctaAction = _data_creditCardAccountPlacement.ctaAction,
    ctaIcon = _data_creditCardAccountPlacement.ctaIcon,
    stylizedHeading = _data_creditCardAccountPlacement.stylizedHeading,
    impressionAnalytics = _data_creditCardAccountPlacement.impressionAnalytics,
    subHeading = _data_creditCardAccountPlacement.subHeading;
  var accessibility = ctaAction.accessibility,
    clickAnalytics = ctaAction.analytics,
    resource = ctaAction.resource;
  var variantOptions = inputs.variant === "SMALL" /* SMALL */ ? smallAccountPlacementOptions : mediumAccountPlacementOptions;
  var isFallback = bottomLabel || stylizedHeading.inlineContent.some(function (content) {
    return content.__typename === "EGDSPlainText";
  });
  var imageWidth = isFallback ? variantOptions.fallbackImageWidth : variantOptions.newImageWidth;
  var containerWidth = parseInt(imageWidth.toString(), 10);
  var onClickTracking = function () {
    trackClick(clickAnalytics.referrerId, clickAnalytics.linkName);
  };
  return /* @__PURE__ */React10.createElement(IntersectionTracker, {
    referrerId: impressionAnalytics.referrerId,
    linkName: impressionAnalytics.linkName
  }, /* @__PURE__ */React10.createElement(EGDSCard, {
    border: true
  }, /* @__PURE__ */React10.createElement(EGDSCardContentSection, {
    padded: true
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlex, {
    space: variantOptions.flexGap
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem, {
    grow: 1,
    maxWidth: containerWidth
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlex, {
    alignItems: "center",
    justifyContent: "center"
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React10.createElement(EGDSLayoutGrid, {
    autoRows: variantOptions.imageHeight,
    autoColumns: imageWidth
  }, /* @__PURE__ */React10.createElement(Image, {
    data: cardImage,
    imageFit: "contain",
    ratio: EGDSFigureAspectRatioType2.R1_1
  }))))), /* @__PURE__ */React10.createElement(EGDSLayoutFlex, {
    direction: "column",
    justifyContent: "center"
  }, /* @__PURE__ */React10.createElement(EGDSHeading, {
    tag: "h3"
  }, /* @__PURE__ */React10.createElement(CreditCardSpannableText, {
    data: stylizedHeading,
    size: variantOptions.headingSize
  })), /* @__PURE__ */React10.createElement(EGDSSpacing, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React10.createElement(EGDSText3, {
    size: 200
  }, subHeading)), bottomLinkText && /* @__PURE__ */React10.createElement(EGDSSpacing, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React10.createElement(EGDSLayoutPosition, {
    position: {
      zindex: "layer1"
    }
  }, /* @__PURE__ */React10.createElement(EGDSLink2, {
    "aria-hidden": "true"
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlex, {
    alignItems: "center",
    space: "one"
  }, bottomLinkText, /* @__PURE__ */React10.createElement(Icon, {
    data: ctaIcon,
    size: EGDSIconSize2.SMALL,
    themeOverride: true,
    isAriaHidden: true
  })))))), !bottomLinkText && !bottomLabel && /* @__PURE__ */React10.createElement(ChevronIcon, {
    ctaIcon: ctaIcon
  }))), bottomLabel && /* @__PURE__ */React10.createElement(EGDSCardContentSection, {
    padded: true,
    border: "top"
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlex, {
    alignItems: "center"
  }, /* @__PURE__ */React10.createElement(EGDSHeading, {
    tag: "h4",
    size: 7
  }, bottomLabel), /* @__PURE__ */React10.createElement(ChevronIcon, {
    ctaIcon: ctaIcon
  }))), /* @__PURE__ */React10.createElement(EGDSCardLink, null, /* @__PURE__ */React10.createElement("a", {
    href: resource.value,
    onClick: onClickTracking,
    target: ctaAction.target === "EXTERNAL" ? "_blank" : void 0,
    rel: "noopener"
  }, accessibility))));
};
AccountPlacement.displayName = "sharedui-CreditCardAccountPlacement";
export { AccountPlacement, CreditCardAccountPlacementSourcePage, CreditCardAccountPlacementVariant };